import { CardsViewAttributeOption, CardsViewSortOption } from "@organisms/ObjectsView/CardsView/CardsView.types"

export const JOB_CARDS_VIEW_ATTRIBUTE_OPTIONS: CardsViewAttributeOption<Job>[] = [
    { name: "assigned_technicians", label: "Assignees" },
    { name: "start_time", label: "Scheduled For" },
    { name: "duration", label: "Duration" },
    { name: "priority", label: "Priority" },
    { name: "recall_to", label: "Recall" },
    { name: "series", label: "Series" },
    { name: "last_modified_at", label: "Last Modified" },
    { name: "labels", label: "Labels" },
]

export const JOB_CARDS_VIEW_SORT_OPTIONS: CardsViewSortOption<Job>[] = [
    { name: "id", label: "ID" },
    { name: "service_name", label: "Service" },
    { name: "status_label", label: "Status" },
    { name: "priority", label: "Priority" },
    { name: "origin_type_label", label: "Source" },
    { name: "origin_id", label: "Source ID" },
    { name: "date_received", label: "Date Received" },
    { name: "client_name", label: "Client" },
    { name: "service_location_name", label: "Location Name" },
    { name: "service_location_address", label: "Location Address" },
    { name: "start_time", label: "Scheduled For" },
    { name: "duration", label: "Duration" },
    { name: "last_scheduled_at", label: "Scheduled" },
    { name: "last_modified_at", label: "Last Modified" },
    { name: "last_active_at", label: "Active" },
    { name: "last_paused_at", label: "Paused" },
    { name: "last_on_hold_at", label: "On Hold" },
    { name: "last_completed_at", label: "Completed" },
    { name: "last_finalized_at", label: "Finalized" },
    { name: "last_cancelled_at", label: "Cancelled" },
]
